import Extend from 'flarum/common/extenders';
import commonExtend from '../common/extend';
import PostAwaitingApprovalNotification from './components/PostAwaitingApprovalNotification';
export default [...commonExtend, new Extend.Notification() //
.add('postAwaitingApproval', PostAwaitingApprovalNotification)];